import React from "react";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/App";
import { reviewsData } from "@/i18n";

export default function Reviews() {
  const { lang, t } = useLang();
  return (
    <section id="opiniones" className="py-20 md:py-28 bg-slate-50" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-widest text-sky-700">
            {t.reviews.kicker}
          </p>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.1]">
            {t.reviews.title}
          </h2>
          <p className="mt-5 text-lg text-slate-700">{t.reviews.subtitle}</p>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-lg font-bold text-slate-900">5.0</span>
            <span className="text-slate-600">· Google</span>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviewsData.map((r, i) => (
            <article
              key={i}
              className="bg-white rounded-2xl p-7 border border-slate-200 hover:shadow-lg transition-shadow"
              data-testid={`review-card-${i}`}
            >
              <Quote className="w-8 h-8 text-sky-200" />
              <div className="mt-3 flex">
                {[...Array(r.rating)].map((_, k) => (
                  <Star key={k} className="w-5 h-5 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="mt-4 text-base text-slate-700 leading-relaxed">
                "{lang === "en" ? r.text_en : r.text}"
              </p>
              <div className="mt-6 flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="grid place-items-center w-11 h-11 rounded-full bg-blue-900 text-white font-bold">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-slate-900">{r.name}</div>
                  <div className="text-sm text-slate-500">{r.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
